var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#D4450C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-280v-280h80v280h-80Zm240 0v-280h80v280h-80ZM80-120v-80h800v80H80Zm600-160v-280h80v280h-80ZM80-640v-80l400-200 400 200v80H80Zm178-80h444-444Zm0 0h444L480-830 258-720Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjRDQ0NTBDIj48cGF0aCBkPSJNMjAwLTI4MHYtMjgwaDgwdjI4MGgtODBabTI0MCAwdi0yODBoODB2MjgwaC04MFpNODAtMTIwdi04MGg4MDB2ODBIODBabTYwMC0xNjB2LTI4MGg4MHYyODBoLTgwWk04MC02NDB2LTgwbDQwMC0yMDAgNDAwIDIwMHY4MEg4MFptMTc4LTgwaDQ0NC00NDRabTAgMGg0NDRMNDgwLTgzMCAyNTgtNzIwWiIvPjwvc3ZnPg==";
export { ForwardRef as ReactComponent };